import type { WikiCategory, WikiExterior, WikiSkinSort } from '../../services/generated/Api';

export {
  WikiCategory,
  WikiExterior,
  WikiLang,
  WikiRareKind,
  WikiSearchType,
  WikiSelectionLayout,
  WikiSkinSort,
  WikiVariantKind,
} from '../../services/generated/Api';

export type {
  WikiCategoryCard,
  WikiCollectionCard,
  WikiCollectionPage,
  WikiCollections,
  WikiContainerCard,
  WikiContainerPage,
  WikiContainers,
  WikiEntityLink,
  WikiGuideCard,
  WikiGuidePage,
  WikiGuides,
  WikiHome,
  WikiPageText,
  WikiRarity,
  WikiRarityGroup,
  WikiSearchHit,
  WikiSearchPage,
  WikiSelectionCard,
  WikiSelectionPage,
  WikiSelections,
  WikiSitemap,
  WikiSitemapEntry,
  WikiSkinCard,
  WikiSkinDetails,
  WikiSkinFacets,
  WikiSkinRedirect,
  WikiSkinsPage,
  WikiVariant,
  WikiWeaponCard,
  WikiWeaponPage,
} from '../../services/generated/Api';

export type WikiSkinsQuery = {
  weapon?: string[];
  category?: WikiCategory[];
  rarity?: string[];
  collection?: string[];
  container?: string[];
  stattrak?: boolean;
  souvenir?: boolean;
  exterior?: WikiExterior[];
  sort?: WikiSkinSort;
  page?: number;
};
